<div class="disclaimer-text">
  <span class="hide-on-large">Nutrigenic operates exclusively as a </span><span class="highlight">Subscription-based meal delivery service.</span><br>
  <span class="highlight">Pause</span> or <span class="highlight">Cancel</span> anytime after the second week. <br>
  That's the <span class="brand">NutriGenic</span> way. 
  <div class="fm-rubik" style="font-size: 0.857rem; color: #2C2C30;">
                        *By placing your order, you agree to our <u style="cursor: pointer;" (click)="goToTerms()">Terms & Conditions</u>
                    </div>
</div>


